/**
 * Represents an error with a known error code.
 */
export class ErrorWithCode extends Error {
    constructor(errorCode, message) {
        super(message);
        this.errorCode = errorCode;
    }
}
//# sourceMappingURL=error-with-code.js.map